import React from 'react';
import {Box, Container, Grid2, Typography} from '@mui/material';

function ProjectTwoColumns({children, withBackground, title}) {
    return (
        <Box sx={{
            backgroundColor: withBackground ? '#f5f5f5' : 'transparent',
            width: '100%',
            py: {xs: '32px', md: '48px'},
        }}>
            <Container sx={{maxWidth: 'md'}}>
                {title && (
                    <Typography variant="h4" fontWeight="bold" sx={{mb: '24px', textAlign: 'center'}}>
                        {title}
                    </Typography>
                )}
                <Grid2 container spacing={{xs: 4, md: 6}}>
                    {React.Children.map(children, (child, i) => (
                        <Grid2 key={i} size={{xs: 12, sm: 6}}>
                            {child}
                        </Grid2>
                    ))}
                </Grid2>
            </Container>
        </Box>
    );
}

export default ProjectTwoColumns;
